import { styled } from "@mui/material";
import FA__ellipsis from "../../../assets/icons/ellipsis-regular-full.svg";

const OptionIcon = styled("div")(() => ({
  width: "24px",
  height: "24px",
  mask: `url("${FA__ellipsis}") no-repeat center / contain`,
  WebkitMask: `url("${FA__ellipsis}") no-repeat center / contain`,
  backgroundColor: "currentColor",
}));

export default OptionIcon;
